import React from 'react'
import jwtDecode from 'jwt-decode'

import Providers from 'layouts/Providers'
import { GlobalStyle } from 'styles/global'

import 'styles/fonts.css'

window.dataObject = {
  page: window.location.pathname,
  url: window.location.href,
  cartProduct: [],
  handProduct: [],
  time: Date(),
  event: window.location.pathname.match(/(checkout|order-confirmation)/g)
    ? []
    : [
        {
          name: 'screenLoad',
          page: window.location.pathname,
          url: window.location.href,
          time: Date()
        }
      ],
  user: {
    userID: localStorage.token ? jwtDecode(localStorage.token).id : null,
    verifiedEmail: localStorage.user ? JSON.parse(localStorage.user).emailVerified : null
  }
}

export const wrapRootElement = ({ element, ...props }, ...args) => {
  return (
    <Providers {...props} {...args}>
      {element}
    </Providers>
  )
}

export const wrapPageElement = ({ element, props }) => (
  <>
    <GlobalStyle />
    {element}
  </>
)